"use strict";

var _index = require("../../types/index.cjs");
var Provider = _index.CoverageEntry.Provider;